export enum ScheduleDialogType {
    PublishSection = 'publish-section',
    SurveyReminder = 'survey-reminder',
    NotifyAll = 'notify-all',
    NotifySelected = 'notify-selected',
    PasswordlessAccess = 'passwordless-access',
    PublishNode = 'publish-node',
}
